import type { ReactNode } from 'react';
import SectionNum from '@/components/ui/SectionNum/SectionNum';
import { chapterMeta, type ChapterId } from '@/lib/chapters';
import { useChapterNumber } from './ChapterNumbering';
import styles from './ChapterSection.module.css';

type Props = {
  id: ChapterId;
  children?: ReactNode;
};

// 章扉。題・短題は lib/chapters.ts の CHAPTERS、番号はページが渡す表示中の並び
// (ChapterNumberingProvider) から取る。章コンポーネント側は id を名乗るだけでよい。
export default function ChapterSection({ id, children }: Props) {
  const { title, shortTitle } = chapterMeta(id);
  const { num, total } = useChapterNumber(id);
  return (
    <section
      id={id}
      className={styles.section}
      aria-labelledby={`${id}-title`}
    >
      <div className={styles.inner}>
        <header className={styles.header}>
          <div className={styles.headTop}>
            <SectionNum number={num} label={shortTitle} />
            <span className={styles.pageNum}>
              {num} / {total}
            </span>
          </div>
          <h2 className={styles.title} id={`${id}-title`}>
            {title}
          </h2>
        </header>
        <div className={styles.body}>{children}</div>
      </div>
    </section>
  );
}
